<div class="main-page">
  <router-outlet></router-outlet>
</div>
